import React, { useState } from "react";
import "./EmployeeFormModal.css";
import {
    createEmployee,
    updateEmployee
} from "../../api/adminEmployeeApi";

const EmployeeFormModal = ({ mode, employee, onClose, onSuccess }) => {
    const isEdit = mode === "edit";

    const [form, setForm] = useState({
        name: employee?.name || "",
        email: employee?.email || "",
        role: employee?.role || "EMPLOYEE",
        status: employee?.status || "ACTIVE"
    });

    const [submitting, setSubmitting] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        try {
            if (isEdit) {
                await updateEmployee(employee.id, {
                    name: form.name,
                    role: form.role,
                    status: form.status
                });
            } else {
                await createEmployee({
                    name: form.name,
                    email: form.email,
                    role: form.role
                });
            }

            onSuccess();
            onClose();
        } catch (e) {
            alert("Operation failed");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-card">
                <h2>{isEdit ? "Edit Employee" : "Create Employee"}</h2>

                <form onSubmit={handleSubmit}>
                    <input
                        name="name"
                        placeholder="Full Name"
                        value={form.name}
                        onChange={handleChange}
                        required
                    />

                    <input
                        name="email"
                        placeholder="Email"
                        value={form.email}
                        onChange={handleChange}
                        disabled={isEdit}
                        required
                    />

                    <select
                        name="role"
                        value={form.role}
                        onChange={handleChange}
                    >
                        <option value="EMPLOYEE">Employee</option>
                        <option value="ADMIN">Admin</option>
                    </select>

                    {isEdit && (
                        <select
                            name="status"
                            value={form.status}
                            onChange={handleChange}
                        >
                            <option value="ACTIVE">Active</option>
                            <option value="INACTIVE">Inactive</option>
                        </select>
                    )}

                    <div className="modal-actions">
                        <button
                            type="button"
                            className="secondary"
                            onClick={onClose}
                        >
                            Cancel
                        </button>

                        <button type="submit" disabled={submitting}>
                            {submitting
                                ? isEdit ? "Saving..." : "Creating..."
                                : isEdit ? "Save Changes" : "Create"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EmployeeFormModal;
